export default {
  data() {
    return {
      Loading: false,
      Error: null,
    };
  },
  methods: {
    async fetchData(method, params) {
      this.Loading = true;
      try {
        this.Loading = true
        const result = await method(params)
        this.Loading = false
        return result
      } catch (e) {
        console.error(e)
        this.Loading = false
        this.$notify('Error fetching data', 'error')
      }
    },
    async fetchDataCallBack(fn) {
      this.Loading = true;
      try {
        this.Loading = true
        await fn()
        this.Loading = false
      } catch (e) {
        console.error(e)
        this.Loading = false
        this.$notify('Error fetching data', 'error')
      }
    },
  },
}
